const mergeArray = (myArr: Array<string>) => {
  let arr: Array<string> = [];

  myArr?.forEach((e) => {
    if (!arr.includes(e)) {
      arr.push(e);
    }
  });

  return arr;
};

export default mergeArray;
